import { IconButton, IconButtonVariant } from "shared/components";
import { XClose } from "untitledui-js-base";

interface HeaderProps {
  onClose: () => void;
}

export const Header = ({ onClose }: HeaderProps) => {
  return (
    <div className="mb-[96px] w-full">
      <div className="fixed flex z-[12] w-full rounded-t-md max-w-[1000px] bg-white justify-between h-[96px] p-8 items-center border-b border-alpha-100">
        <p className="text-content-1000 font-bold text-xl">
          Decision recommendation details
        </p>

        <IconButton
          variant={IconButtonVariant.BASE}
          borderLess
          className="stroke-content-200"
          onClick={onClose}
          Icon={XClose}
        />
      </div>
    </div>
  );
};
